import React, { type FC } from 'react';

import { CircularLoadingAnimation } from '@/common/circular-loading-animation';
import { FloatingPanel, FloatingPanelItem, FloatingPanelType } from '@/common/floating-panel';
import { IntaglioIcon } from '@/common/intaglio-icon';
import { Navbar, NavbarType } from '@/common/navbar';
import { Skeleton } from '@/common/skeleton';

export const LoadingScreen: FC = () => {
    return (
        <div className="flex flex-col min-h-0 h-screen w-full bg-black-50">
            <Navbar
                type={NavbarType.LIGHT}
                leading={
                    <div className="flex flex-row gap-4 items-center">
                        <IntaglioIcon />
                        <Skeleton className="w-32 h-5" />
                    </div>
                }
                center={<div />}
                trailing={<div className="bg-blue-60 h-9 w-28 rounded" />}
            />

            <div className="flex min-h-0 flex-row h-full max-w-full min-w-full">
                <FloatingPanel className="pl-4 py-4 h-full w-64 flex-shrink-0 flex-grow-0" type={FloatingPanelType.LIGHT}>
                    <FloatingPanelItem className="px-4">
                        <div className="flex flex-col gap-1">
                            <Skeleton className="w-40 h-5 mt-1" />
                        </div>
                    </FloatingPanelItem>

                    <FloatingPanelItem className=" px-4 flex flex-col gap-2 h-full max-h-full min-h-0">
                        <Skeleton className="w-20 h-5 mt-4" />
                        <div className="w-full bg-black-50 h-40 rounded " />
                        <div className="flex flex-row items-center justify-between">
                            <Skeleton className="w-24 h-5" />
                        </div>
                    </FloatingPanelItem>
                </FloatingPanel>

                <div className="w-full h-full flex flex-col items-center justify-center">
                    <CircularLoadingAnimation className="w-16 h-16" />
                    <p className="text-gray-60 text-2xl">Loading creative...</p>
                </div>

                <FloatingPanel
                    className="pr-4 py-4 h-full w-80 flex-shrink-0 flex-grow-0"
                    type={FloatingPanelType.LIGHT}
                    width={360}
                >
                    <FloatingPanelItem className="px-4">
                        <div className="flex flex-row items-center justify-between">
                            <Skeleton className="w-32 h-5" />
                        </div>
                    </FloatingPanelItem>

                    <FloatingPanelItem className="flex flex-col items-center justify-center gap-2 h-full max-h-full min-h-0">
                        <Skeleton className="w-[80%] h-5" />
                        <Skeleton className="w-[60%] h-5" />
                    </FloatingPanelItem>
                </FloatingPanel>
            </div>
        </div>
    );
};
